export const RiskRating = {
	A: 0,
	B: 1,
	C: 2,
};
